const Gaming = () => (
  <h1>Gaming</h1>
);
export default Gaming;
